export const USER_METADATA_URL = "https://api.genira.com/metadata";
